import Link from 'components/ui/Link';
import useSelector from 'hooks/use-selector';
import isEqual from 'lodash/isEqual';
import React, { useMemo, PropsWithChildren } from 'react';
import { getSiteCollectionsMap } from 'services/app/selectors';
type IProps = PropsWithChildren<{
  className?: string;
  collection?: string;
  'data-testid'?: string;
  onClick?: () => void;
  plain?: boolean;
  query?: Record<string, string>;
  slug?: string;
}>;

const ObjectLink = ({
  children,
  className,
  collection,
  onClick,
  plain,
  query,
  slug,
  ...props
}: IProps) => {
  const collectionSlugMap = useSelector(getSiteCollectionsMap, isEqual);


  const internalRef = useMemo(() => {
    if (!slug || typeof slug !== 'string') {
      return '';
    }

    if (collection !== 'pages') {
      return `/${collectionSlugMap[collection!].slug}/${slug}`;
    }

    return `/${slug}`;
  }, [
    collection,
    JSON.stringify(collectionSlugMap),
    slug,
  ]);

  return (
    <Link
      className={className}
      data-testid={props['data-testid']}
      href={internalRef}
      onClick={onClick}
      plain={plain}
      query={query}
    >
      {children}
    </Link>
  );
};

ObjectLink.defaultProps = {
  className: '',
  collection: 'pages',
  onClick: undefined,
  plain: true,
  query: undefined,
  slug: '',
};

export default ObjectLink;
